import React from "react";
import { startOfMonth } from "date-fns";

import {
  Header,
  HeaderDate,
  CalendarPeriod,
  HeaderControls,
  IconBottonGroup
} from "./styles";
import Button from "../common/Button";
import IconButton from "../common/IconButton";
import ChannelToggle from "../common/ChannelToggle";
import ScheduleViewToggle from "./ScheduleViewToggle";
import { useComposerActions } from "contextApi/composerContext";
import { getOffsetDate, getFormattedDate } from "./utils/dateUtils";

function ScheduleHeader({
  today,
  channels,
  currentDate,
  onChangeDate,
  isSidebarVisible,
  selectedChannelIds,
  handleChannelChange,
  createPostsFilter
}) {
  const createTask = useComposerActions(actions => actions.createTask);

  const formattedDate = getFormattedDate(currentDate, "MMMM	yyyy");
  const handleChangeMonth = direction => {
    let newDate = getOffsetDate(startOfMonth(currentDate), {
      months: direction === "next" ? 1 : -1
    });
    onChangeDate(newDate);
  };
  const handleTodayClick = () => {
    onChangeDate(today);
  };

  return (
    <Header>
      <CalendarPeriod>
        <Button size={"sm"} variant={"secondary"} onClick={handleTodayClick}>
          Today
        </Button>
        <IconBottonGroup>
          <IconButton
            icon="icon-arrowleft"
            variant={"secondary"}
            size={36}
            iconSize={24}
            iconColor={"#646769"}
            onClick={() => handleChangeMonth("prev")}
          />
          <IconButton
            icon="icon-arrowright"
            variant={"secondary"}
            size={36}
            iconSize={24}
            iconColor={"#646769"}
            onClick={() => handleChangeMonth("next")}
          />
        </IconBottonGroup>
        <HeaderDate>{formattedDate}</HeaderDate>
      </CalendarPeriod>
      <ScheduleViewToggle defaultValue="month" />
      <HeaderControls>
        {channels.length > 0 && (
          <ChannelToggle
            gap={0}
            adjustPosition={true}
            channels={channels}
            selectedIds={selectedChannelIds}
            onSave={handleChannelChange}
            createPostsFilter={createPostsFilter}
            showDropdown={true}
          />
        )}
        {!isSidebarVisible && (
          <Button onClick={() => createTask()} isRounded>
            Add tasks
          </Button>
        )}
      </HeaderControls>
    </Header>
  );
}

export default ScheduleHeader;
